import React, { useState } from "react";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import LucideIcon from "../../../components/LucideIcon";
import LoadingButton from "../../../components/LoadingButton";

interface CancelTerminationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  companyName: string;
  companyId: string;
}

const CancelTerminationDialog: React.FC<CancelTerminationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  companyName,
  companyId,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const handleConfirm = async () => {
    setSubmitting(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Dialog open={open} onClose={submitting ? undefined : onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
        Cancel termination
        <IconButton onClick={onClose} disabled={submitting} size="small">
          <LucideIcon name="X" size={20} />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Alert severity="info">
          Cancel the scheduled deletion for <strong>{companyName || companyId}</strong>?
          The company will remain active and the termination timer will be cleared.
        </Alert>
      </DialogContent>
      <DialogActions>
        <LoadingButton onClick={onClose} disabled={submitting}>
          Back
        </LoadingButton>
        <LoadingButton loading={submitting} onClick={handleConfirm} variant="contained">
          Cancel termination
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export default CancelTerminationDialog;
